import React from "react"
import { motion } from "framer-motion"

interface PageTransitionProps {
	children: React.ReactNode
}

export const PageTransition: React.FC<PageTransitionProps> = ({ children }) => (
	<motion.div
		initial={{ opacity: 0, y: 8 }}
		animate={{ opacity: 1, y: 0 }}
		exit={{ opacity: 0, y: -8 }}
		transition={{ duration: 0.25, ease: "easeOut" }}
		style={{ width: "100%" }}
	>
		{children}
	</motion.div>
)